import { render } from "./ProductSettings.vue?vue&type=template&id=8647c4ae"
import script from "./ProductSettings.vue?vue&type=script&lang=js"
export * from "./ProductSettings.vue?vue&type=script&lang=js"
script.render = render

export default script